// extracted by mini-css-extract-plugin
export default {"negative":"Negative-module__negative--q1ctT","copilotRun":"Negative-module__copilotRun--PYLrI"};